export const DEFAULTS = {
    fontSize: '15px',
    fontFamily: 'Georgia',
    color: '#1218CE'
};
